/* eslint-disable @typescript-eslint/ban-ts-comment */
// StepOne.tsx
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import { useYupValidationResolver } from 'hooks/useYupValidationResolver';
import useLayoutController from 'components/Stepper/RouteBasedStepper/useLayoutController';
import { useCreateCaseState } from './CreateCaseManager';

const reasonsWithSpecifications = ['5600', '5606']; // These are the reasons that require a specification

const useReasonForSale = () => {
    const { saveCaseManagementData, reasonForSaleData, reasonForSaleOptions } = useCreateCaseState();

    const schema = yup.object({
        ReasonListItemId: yup.string().required('createNewCase.ReasonForSale.Input.reasonForSale.Error.Required'),
        ReasonText: yup
            .string()
            .max(65, 'createNewCase.ReasonForSale.Input.specifyReason.Error.TooLong')
            .nullable(),
    });

    type FormData = yup.InferType<typeof schema>;
    const {
        register, control, handleSubmit, setValue, watch, formState: { errors },
    } = useForm<FormData>({
        resolver: useYupValidationResolver(schema),
        defaultValues: { ...reasonForSaleData },
    });

    const formData = watch();

    const onSubmit = useCallback(async (data: FormData) => {
        if (data) {
            saveCaseManagementData({
                reasonForSaleData: data,
            });
            setStepComplete(true);
        }
    }, []);

    const { setStepComplete } = useLayoutController({
        callbackOnContinue: handleSubmit(onSubmit),
        isContinueDisabled: Object.entries(errors)?.length > 0 || false,
    });

    return {
        data: formData, reasonForSaleOptions, reasonsWithSpecifications, register, control, setData: setValue, errors,
    };
};

export default useReasonForSale;
